import {
  CREATE_INTEGRATION,
  GET_INTEGRATIONS,
  UPDATE_INTEGRATION,
  DELETE_INTEGRATION,
  GET_SF_LEAD_INTEGRATION_MACROS,
  TEST_INTEGRATION,
  GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE,
  GET_INTEGRATION_TEMPLATES,
  DUPLICATE_INTEGRATIONS,
  GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES,
  GET_LEAD_INTEGRATION_LOGS_BY_ID,
  EXPORT_LEAD_INTEGRATION_LOGS,
  GET_CAMPAIGNS_BY_INTEGRATION,
  GET_INTEGRATIONS_STATS_BY_DATES,
  GET_INTEGRATIONS_FAILURE_REASON_STATS,
  GET_INTEGRATIONS_STATS,
  GET_RESPONSE_PARSER_FUNCTIONS,
  GET_INTERMEDIATE_LEAD_INTEGRATIONS,
  UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS,
  GET_INTEGRATION_SAMPLE_LEADS,
} from "./actionTypes"

import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"
import { createIntegrationSuccess, createIntegrationError, getIntegrationsSuccess, getIntegrationsError, updateIntegrationSuccess, updateIntegrationError, deleteIntegrationSuccess, deleteIntegrationError, getSfLeadIntegrationMacrosSuccess, getSfLeadIntegrationMacrosError, testIntegrationSuccess, testIntegrationError, getLeadIntegrationDefaultPayloadValueSuccess, getLeadIntegrationDefaultPayloadValueError, getIntegrationTemplatesSuccess, getIntegrationTemplatesError, duplicateIntegrationsSuccess, duplicateIntegrationsError, getSfLeadIntegrationMacroCategoriesSuccess, getSfLeadIntegrationMacroCategoriesError, getLeadIntegrationLogsByIdSuccess, getLeadIntegrationLogsByIdError, exportLeadIntegrationLogsSuccess, exportLeadIntegrationLogsError, getCampaignsByIntegrationSuccess, getCampaignsByIntegrationError, getIntegrationStatsByDatesSuccess, getIntegrationStatsByDatesError, getIntegrationFailureReasonStatsError, getIntegrationFailureReasonStatsSuccess, getIntegrationsStatsSuccess, getIntegrationsStatsError, getResponseParserFunctionsSuccess, getResponseParserFunctionsError, getIntermediateLeadIntegrationsSuccess, getIntermediateLeadIntegrationsError, getIntegrationsSampleLeadsSuccess, getIntegrationsSampleLeadsError } from "./actions"
import { AppConfiguration } from "config";
import { genericDeleteRequest, genericGetRequest, genericGetRequest_2, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper";
import { NAME_OF_INTEGRATIONS, getProductTypeById } from "helpers/sf_constants";
import Swal from "sweetalert2";
import { bsh_getClientUserDetails, STORAGE_KEY } from "helpers/sf_browser_storage_helper";
import { buildCampaignAnalysisCacheKey, showErrorToast } from "helpers/sf_utils";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";

const changeToAdminRoute = (org_route) => {
  const isClientUserPresent = !!bsh_getClientUserDetails()

  const route = isClientUserPresent ? org_route : `admin_${org_route}`

  const authtoken = isClientUserPresent ? bsh_getClientUserDetails() : JSON.parse(localStorage.getItem(STORAGE_KEY.AUTH_ADMIN_USER))

  return { authtoken, route }
}

function* onGetIntegrations() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_integrations`,
      {},
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getIntegrationsSuccess(response))
  } catch (error) {
    yield put(getIntegrationsError(error))
  }
}

function* onGetResponseParserFunctions() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_resource_parser_functions`,
      {},
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getResponseParserFunctionsSuccess(response))
  } catch (error) {
    yield put(getResponseParserFunctionsError(error))
  }
}

function* onGetIntermediateLeadIntegrations(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_intermediate_lead_integrations/${action?.payload?.intermediate_integration_id}`,
      { ...action?.payload },
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getIntermediateLeadIntegrationsSuccess(response?.data))
  } catch (error) {
    yield put(getIntermediateLeadIntegrationsError(error))
  }
}

function* onUpdateIntermediateLeadIntegrations(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/update_intermediate_lead_integrations/${action?.payload?.intermediate_integration_id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          "account-id": user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(getIntermediateLeadIntegrationsSuccess(response?.data))
  } catch (error) {
    yield put(getIntermediateLeadIntegrationsError(error))
  }
}

function* onGetIntegrationsStatsByDates(action) {
  try {
    const { authtoken, route } = changeToAdminRoute('get_lead_integrations_stats_by_dates')
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/${route}/${action?.payload?.integration_log_id}`,
      { ...action?.payload },
      {
        "Authorization": authtoken?.token,
        "account-id": authtoken?.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getIntegrationStatsByDatesSuccess(response))
  } catch (error) {
    yield put(getIntegrationStatsByDatesError(error))
  }
}
function* onGetIntegrationsFailureReasonStats(action) {
  try {
    const { authtoken, route } = changeToAdminRoute('get_lead_integrations_failure_stats')
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/${route}/${action?.payload?.integration_log_id}`,
      { ...action?.payload },
      {
        "Authorization": authtoken?.token,
        "account-id": authtoken?.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getIntegrationFailureReasonStatsSuccess(response?.data))
  } catch (error) {
    yield put(getIntegrationFailureReasonStatsError(error))
  }
}
function* onGetIntegrationStats(action) {
  try {
    const { authtoken, route } = changeToAdminRoute('stats_by_integration')
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/${route}`,
      { ...action?.payload },
      {
        "Authorization": authtoken?.token,
        "account-id": authtoken?.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getIntegrationsStatsSuccess(response))
  } catch (error) {
    yield put(getIntegrationsStatsError(error))
  }
}
// `${AppConfiguration.BACKEND_URL}/api/v1/integrations`,
function* onGetsfLeadIntegrationMacros() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/sf_lead_integration_macros`,
      {},
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getSfLeadIntegrationMacrosSuccess(response))
  } catch (error) {
    yield put(getSfLeadIntegrationMacrosError(error))
  }
}

function* onCreateIntegration({ payload: { integration, history } }) {
  const product_type_id = integration.lead_integration?.product_type_id;
  const product_type_name = getProductTypeById(product_type_id)?.name;
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_integrations`,
      {
        body: JSON.stringify({
          ...integration
        }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createIntegrationSuccess(response))
    const created_id = response?.[0].id
    if (created_id) {
      history.push(`/integrations/edit/${created_id}?open_accordion=${NAME_OF_INTEGRATIONS.REQUEST_HEADERS.ID}`)
    }
  } catch (error) {
    yield put(createIntegrationError(error))
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: `Unable to create a ${product_type_name} integration!`,
      footer: '<a href="/integrations/create">Can you try again?</a>'
    })
  }
}

function* onUpdateIntegration(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_integrations/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'accept': 'application/json',
        }
      }
    )
    yield put(updateIntegrationSuccess(response))
  } catch (error) {
    showErrorToast(error, 'An error occurred while updating the integration')
    yield put(updateIntegrationError(error))
  }
}

function* onDeleteIntegration(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_integrations/${action.payload.id}`,
      {
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'accept': 'application/json',
        }
      }
    )
    yield put(deleteIntegrationSuccess(response))
  } catch (error) {
    showErrorToast(error, 'An error occurred while deleting the integration')
    yield put(deleteIntegrationError(error))
  }
}

function* onTestIntegration(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const lead_integration_id = action?.payload?.id
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_integrations/test/${lead_integration_id}`,
      {
        body: JSON.stringify({ ...action?.payload }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(testIntegrationSuccess(response))
  } catch (error) {
    yield put(testIntegrationError(error))
  }
}

function* onGetLeadIntegrationDefaultPayloadValue(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const lead_integration_id = action?.payload?.id
    const product_type_id = action?.payload?.product_type_id
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_integrations/mapped_variables/${lead_integration_id}`,
      {
        body: JSON.stringify(product_type_id ? { product_type_id } : {}),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(getLeadIntegrationDefaultPayloadValueSuccess(response))
  } catch (error) {
    yield put(getLeadIntegrationDefaultPayloadValueError(error))
  }
}

function* onGetIntegrationTemplates(_action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_integrations/templates/index`,
      {},
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getIntegrationTemplatesSuccess(response))
  } catch (error) {
    yield put(getIntegrationTemplatesError(error))
  }
}

function* onDuplicateIntegrations(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const ids = (action.payload?.ids || []).join(',')
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_integrations/duplicate/${ids}`,
      {
        body: JSON.stringify({}),
        headers: {
          "Authorization": user.token,
          "account-id": user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(duplicateIntegrationsSuccess(response))
  } catch (error) {
    yield put(duplicateIntegrationsError(error))
  }
}

function* onGetSfLeadIntegrationMacroCategories(_action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/sf_lead_integration_macro_categories`,
      {},
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getSfLeadIntegrationMacroCategoriesSuccess(response))
  } catch (error) {
    yield put(getSfLeadIntegrationMacroCategoriesError(error))
  }
}


const inFlightLeadIntegrationLogsRequests = new Set()

function* onGetLeadIntegrationLogsById(action) {
  try {
    const useCache = Boolean(action.payload?.useCache)
    const queryParams = action.payload?.queryParams || {}
    const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
    const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
    const requestKey = `${cacheKey}:${requestedPageNumber}`
    const cachedPage = useCache
      ? yield select((state) => state.Integration.lead_integration_logs_page_cache?.[cacheKey]?.[requestedPageNumber])
      : null

    if (useCache && cachedPage) {
      return
    }

    if (useCache && inFlightLeadIntegrationLogsRequests.has(requestKey)) {
      return
    }

    if (useCache) {
      inFlightLeadIntegrationLogsRequests.add(requestKey)
    }

    const { authtoken, route } = changeToAdminRoute('lead_integrations_logs')
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/${route}/${queryParams.integration_log_id}`,
      { ...queryParams },
      {
        "Authorization": authtoken?.token,
        "account-id": authtoken?.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getLeadIntegrationLogsByIdSuccess(response, {
      queryParams,
      appendResults: Boolean(action.payload?.appendResults),
      replaceResults: Boolean(action.payload?.replaceResults),
      useCache,
    }))
  } catch (error) {
    yield put(getLeadIntegrationLogsByIdError(error))
  } finally {
    if (action.payload?.useCache) {
      const queryParams = action.payload?.queryParams || {}
      const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
      const cacheKey = buildCampaignAnalysisCacheKey(queryParams)
      inFlightLeadIntegrationLogsRequests.delete(`${cacheKey}:${requestedPageNumber}`)
    }
  }
}

function* onExportLeadIntegrationLogs(action) {
  try {
    const integrationLogId = action.payload?.integrationLogId
    const queryParams = action.payload?.queryParams || {}
    const authtoken = bsh_getClientUserDetails()
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/lead_integrations_logs/${integrationLogId}/export`,
      {
        body: JSON.stringify(queryParams),
        headers: {
          "Authorization": authtoken?.token,
          "account-id": authtoken?.account_id,
          "Content-Type": "application/json",
        },
      }
    )
    yield put(exportLeadIntegrationLogsSuccess(response))
    ToastAlert.fire({
      icon: ToastAlertIconType.OK,
      title: "Integration logs export started. You'll receive an email when it's ready.",
    })
  } catch (error) {
    yield put(exportLeadIntegrationLogsError(error))
    ToastAlert.fire({
      icon: ToastAlertIconType.ERROR,
      title: "Unable to start integration logs export.",
    })
  }
}

// campaigns by integration
function* onGetCampaignsByIntegration({ payload: { queryParams } }) {
  try {
    const { authtoken, route } = changeToAdminRoute('campaigns_by_integration')
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/${route}/${queryParams.integration_log_id}`,
      { ...queryParams },
      {
        "Authorization": authtoken?.token,
        "account-id": authtoken?.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getCampaignsByIntegrationSuccess(response))
  } catch (error) {
    yield put(getCampaignsByIntegrationError(error))
  }
}

function* onGetIntegrationSampleLeads(_action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/sample_leads`,
      {},
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getIntegrationsSampleLeadsSuccess(response))
  } catch (error) {
    yield put(getIntegrationsSampleLeadsError(error))
  }
}


function* IntegrationsSaga() {
  yield takeEvery(GET_INTEGRATIONS, onGetIntegrations);
  yield takeEvery(GET_INTERMEDIATE_LEAD_INTEGRATIONS, onGetIntermediateLeadIntegrations);
  yield takeEvery(UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS, onUpdateIntermediateLeadIntegrations);
  yield takeEvery(GET_RESPONSE_PARSER_FUNCTIONS, onGetResponseParserFunctions);
  yield takeEvery(GET_INTEGRATION_TEMPLATES, onGetIntegrationTemplates);
  yield takeEvery(DUPLICATE_INTEGRATIONS, onDuplicateIntegrations);
  yield takeEvery(CREATE_INTEGRATION, onCreateIntegration);
  yield takeEvery(UPDATE_INTEGRATION, onUpdateIntegration);
  yield takeEvery(DELETE_INTEGRATION, onDeleteIntegration);
  yield takeEvery(GET_SF_LEAD_INTEGRATION_MACROS, onGetsfLeadIntegrationMacros);
  yield takeEvery(TEST_INTEGRATION, onTestIntegration);
  yield takeEvery(GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE, onGetLeadIntegrationDefaultPayloadValue);
  yield takeEvery(GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES, onGetSfLeadIntegrationMacroCategories);
  yield takeLatest(GET_LEAD_INTEGRATION_LOGS_BY_ID, onGetLeadIntegrationLogsById);
  yield takeEvery(EXPORT_LEAD_INTEGRATION_LOGS, onExportLeadIntegrationLogs);
  yield takeEvery(GET_CAMPAIGNS_BY_INTEGRATION, onGetCampaignsByIntegration);
  yield takeEvery(GET_INTEGRATIONS_STATS_BY_DATES, onGetIntegrationsStatsByDates);
  yield takeEvery(GET_INTEGRATIONS_FAILURE_REASON_STATS, onGetIntegrationsFailureReasonStats);
  yield takeEvery(GET_INTEGRATION_SAMPLE_LEADS, onGetIntegrationSampleLeads);
  yield takeEvery(GET_INTEGRATIONS_STATS, onGetIntegrationStats);

}

export default IntegrationsSaga;
